<div class="modal-backdrop" (click)="onBackdrop()" *ngIf="open" role="dialog" aria-modal="true">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <button
      #firstFocusable
      class="modal-close"
      type="button"
      aria-label="Close"
      (click)="onCancel()"
    >
      <mat-icon svgIcon="close" class="header-cross-icon"></mat-icon>
    </button>

    <h2 class="modal-title">{{ title }}</h2>

    <ul class="provider-list" role="list">
      <li>
        <button class="provider-item" type="button" (click)="onSelect('gmail')">
          <span class="provider-icon">
            <mat-icon svgIcon="gmail" class="header-cross-icon"></mat-icon>
          </span>
          <span class="provider-label">Gmail</span>
        </button>
      </li>
      <li>
        <button class="provider-item" type="button" (click)="onSelect('outlook')">
          <span class="provider-icon">
            <mat-icon svgIcon="outlook" class="header-cross-icon"></mat-icon>
          </span>
          <span class="provider-label">Outlook</span>
        </button>
      </li>
      <li>
        <button class="provider-item" type="button" (click)="onSelect('default')">
          <span class="provider-icon">
            <mat-icon svgIcon="letter" class="header-cross-icon"></mat-icon>
          </span>
          <span class="provider-label">Default email client</span>
        </button>
      </li>
    </ul>

    <div class="modal-actions">
      <button class="btn btn-cancel" type="button" (click)="onCancel()">Cancel</button>
    </div>
  </div>
</div>
